import React from "react";
import AccordionItem from "./AccordionItem";
import { faqItems } from "../../constants/faqs";
import { AccordionCategoryType } from "../../Interfaces/shared";

const Accordion = ({ category }: {category: AccordionCategoryType}) => {

  return (
    <React.Fragment>
        <div id="gen-ques-accordion" className="accordion custom-accordion">
          {faqItems[category].map((item, index) => <AccordionItem item={item} key={index} />)}
        </div>
    </React.Fragment>
  )
}

export default Accordion;
